import bank from '@/api/corporate/bank-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return bank.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return bank.store(data)
  },
  update(context, { id, data }) {
    return bank.update(id, data)
  },
  
  destroy(context, id){
    return bank.destroy(id)
  },
  upload(context, data) {
    return bank.upload(data)
  },
  qrUpload(context, data) {
    return bank.qrUpload(data)
  }
}
